module.exports = __webpack_public_path__ + "static/media/resultgav.57bf3452.png";